<shared-toolbar title="Usuario">
  @if (!isRole) {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <input
        type="text"
        aria-label="text"
        matInput
        [(ngModel)]="selectedBussinesName"
        [formControl]="myControl"
        [disabled]="!ValidBusiness_id()"
        [matAutocomplete]="auto"
        (keydown)="onKeyDown($event)" />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="
          onOptionSelected($event.option.value, $event.option.viewValue)
        "
        (optionSelected)="sortByBussines()">
        @if (roleName() === 'ACCESOS') {
          <mat-option [value]="null">- ACCESOS -</mat-option>
        }
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.idBusiness">{{ option.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  } @else {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <mat-select
        [disabled]="!ValidBusiness_id()"
        (selectionChange)="sortByBussines()"
        [(value)]="selectedBussines">
        @for (item of bussines; track item) {
          <mat-option [value]="item.idBusiness">{{ item.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
  <shared-button
    (click)="modalAction()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'add'"
    >Agregar
  </shared-button>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table class="w-full" [dataSource]="dataSource" matSort>
      <!-- Position Column -->

      <ng-container matColumnDef="user_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.user_name }}</td>
      </ng-container>

      <ng-container matColumnDef="first_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.first_name }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="last_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Apellido</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.last_name }}</td>
      </ng-container>

      <ng-container matColumnDef="user_code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">
          {{ element.user_code | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="email2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Correo Secundario
        </th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.secondEmail }}</td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Teléfono</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.phone }}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dirección</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.address }}</td>
      </ng-container>

      <ng-container matColumnDef="building_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Edificio</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.building_name }}</td>
      </ng-container>

      <ng-container matColumnDef="workerGroupName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Grupo</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">
          {{ element.workerGroupName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="role_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rol</th>
        <td mat-cell [style]="getRowStyles(element.state)" *matCellDef="let element">{{ element.roleName }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell
        [style]="getRowStyles(element.state)"
        *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="modalAction(element)">
              <mat-icon mat-icon-button>edit</mat-icon>
              <span>Editar</span>
            </a>
            @if (element.state == 'BAJA') {
              <a mat-menu-item (click)="modalAlta(element)">
                <mat-icon mat-icon-button color="warn">perm_identity</mat-icon>
                <span>Activar</span>
              </a>
            }
            @if (element.state == 'ALTA') {
              <a mat-menu-item (click)="modalBaja(element)">
                <mat-icon mat-icon-button color="warn">perm_identity</mat-icon>
                <span>Suspender</span>
              </a>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la búsqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
